import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "./react-tabs.css";
import { RulesList } from "./RuleList";
import { AdministratorsList } from "./AdministratorList";
import { TemplateSiteList } from "./TemplateSiteList";
import styled from "styled-components";
import { CancelConfirmationDialog } from "./CancelConfirmationDialog";
import { ModalDialog } from "store/types";
import { useCallback, useState } from "react";
import { Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "@reach/router";

const PageTitle = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 31px;
  line-height: 31px;
  margin: 0px;
  color: #252525;
  padding-bottom: 24px;
`;

export const AdminSectionTitle = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 25px;
  padding-top: 64px;
  margin: 0px;
`;

export const AdminSectionDescription = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-top: 8px;
  padding-bottom: 16px;
  margin: 0px;
  align-items: left;
  text-align: left;
`;

export const FullWidth = styled.div`
  width: 100%;
`;

export const ApplicationSettings = () => {
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(ModalDialog.NONE);
  const handleCloseModal = useCallback(() => setOpenModal(ModalDialog.NONE), []);
  const handleOpenModal = useCallback(() => setOpenModal(ModalDialog.CANCEL), []);

  const handleCancelChanges = useCallback(() => {
    setOpenModal(ModalDialog.NONE);
    navigate("/");
  }, [navigate]);

  return (
    <>
      <Grid container spacing={1} alignItems="center" style={{ paddingTop: "36px" }}>
        <Grid item xs={11}>
          <PageTitle>Application settings</PageTitle>
        </Grid>
        <Grid item xs={1} style={{ display: "flex", alignItems: "center", justifyContent: "right" }}>
          <IconButton
            aria-label="close"
            onClick={handleOpenModal}
            sx={{
              color: "#414141",
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <FullWidth>
        <Tabs>
          <TabList>
            <Tab>Rules</Tab>
            <Tab>Administrators</Tab>
            <Tab>Template sites</Tab>
          </TabList>
          <TabPanel>
            <RulesList />
          </TabPanel>
          <TabPanel>
            <AdministratorsList />
          </TabPanel>
          <TabPanel>
            <TemplateSiteList />
          </TabPanel>
        </Tabs>
      </FullWidth>
      <CancelConfirmationDialog
        open={openModal === ModalDialog.CANCEL}
        onConfirm={handleCancelChanges}
        onClose={handleCloseModal}
      />
    </>
  );
};
